import { render, staticRenderFns } from "./userpwd.vue?vue&type=template&id=6592c29c&scoped=true"
import script from "./userpwd.vue?vue&type=script&lang=js"
export * from "./userpwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592c29c",
  null
  
)

export default component.exports